module.exports = __webpack_public_path__ + "img/2025-06-11d_3.38dbe496.jpg";